module.exports = __webpack_public_path__ + "static/Illustration-ElMontePizzaCo-f87dcb87161aac444615f2f1bc98c0b5.svg";